import Api from 'libs/api/index';

class WishlistsApi extends Api {
  constructor() {
    super('cv/wishlists/');
  }
}

export default WishlistsApi;
